export default {
  broadcastSchedules: [],
  broadcastSchedule: undefined,
};
